module.exports = __webpack_public_path__ + "img/front-background.909454f.png";